import { snapdom } from '@zumer/snapdom';

/** Дольше пользователь ждать не готов: превью откроется без скриншота */
const CAPTURE_TIMEOUT_MS = 5000;

/**
 * Снимок видимой области текущего экрана средствами DOM-рендеринга.
 * Снимается ровно вьюпорт (у приложения внутренний скролл), без ретина-удвоения:
 * скриншот уходит на сервер файлом, лишние пиксели только раздувают его вес.
 * Возвращает null при любой ошибке или таймауте — отправка текста должна работать и без картинки.
 */
export const captureScreenshot =
  async (): Promise<HTMLCanvasElement | null> => {
    try {
      const timeout = new Promise<null>(resolve => {
        setTimeout(() => resolve(null), CAPTURE_TIMEOUT_MS);
      });

      const capture = snapdom.toCanvas(document.body, {
        clip: 'viewport',
        dpr: 1,
        fast: true,
        scale: 1
      });

      return await Promise.race([capture, timeout]);
    } catch {
      return null;
    }
  };
